// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0cf66368","455":"a9520de0","977":"6ab5cc59"}[chunkId] + ".chunk.js";
};